const tr = {
    en: {
        title: "YAY!",
        subtitle: "We see your subscriptions through {{brand}} include the following:",

        activationPrompt: "Would you like to use these with this account?",

        usedByPrompt: "The subscription is being used by another Now E account: <b> {{email}} </b>",
        transferPrompt: "Switch to use with current Now E account <b>{{email}}</b>?",

        okBtnTxt: "OK",
        cancelBtnTxt: "Cancel",
    },
    zh: {
        title: "謝謝!",
        subtitle: "您透過{{brand}}訂購的服務如下:",

        activationPrompt: "確定於此帳戶上使用以上服務嗎?",

        usedByPrompt: "服務正於另一個Now E帳戶上使用: <b> {{email}} </b>",
        transferPrompt: "確定切換至Now E帳戶<b>{{email}}</b>以使用服務嗎?",

        okBtnTxt: "確定",
        cancelBtnTxt: "取消",
    }
}

export default tr;